<template>
  <!-- Desktop View -->
  <div class="d-none d-lg-block floating-recent-pages">
    <div class="btn-group dropup">
       <button 
    class="recent-pages-button"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    <i class="bi bi-clock-history"></i>
  </button>
      <ul class="dropdown-menu dropdown-menu-end p-2">
        <li v-for="(page, index) in recentPages" :key="index">
          <router-link 
            :to="page.path" 
            class="dropdown-item d-flex align-items-center py-2"
            @click="trackNavigation(page.path)"
          >
            <span class="recent-page-icon me-2" :style="{ color: page.color }">
              <i :class="page.icon"></i>
            </span>
            <div class="d-flex flex-column">
              <span class="fw-bold">{{ page.name }}</span>
              <small class="text-muted">{{ formatTime(page.timestamp) }}</small>
            </div>
          </router-link>
        </li>
        <li v-if="recentPages?.length === 0">
          <span class="dropdown-item text-muted">No recent pages</span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Mobile View -->
  <div class="d-lg-none mobile-recent-pages">
    <div class="position-fixed bottom-0 start-0 p-2 w-100">
      <div class="d-flex overflow-auto py-2">
        <button 
          v-for="(page, index) in recentPages?.slice(0, 5)"
          :key="index"
          class="btn btn-sm me-2 recent-page-btn"
          :style="{ backgroundColor: page.color }"
          @click="navigateTo(page.path)"
        >
          <i :class="`${page.icon} me-1`"></i>
          {{ page.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import store from "@/store";
import { useRouter } from 'vue-router'

const router = useRouter()

// Constants
const colorPalette = [
  '#4e73df', '#1cc88a', '#36b9cc', 
  '#f6c23e', '#e74a3b', '#858796'
]

const iconMap = {
  'dashboard': 'bi-speedometer2',
  'profile': 'bi-person',
  'settings': 'bi-gear',
  'messages': 'bi-chat',
  'analytics': 'bi-graph-up',
  'files': 'bi-folder',
  'default': 'bi-file-earmark'
}

// Access root store with modules
const recentPages = computed(() => store.state.recentPages) // Direct state access
// Or if you want to use the getter:
// const recentPages = computed(() => store.getters['recentPages'])

const routerConfig = computed(() => {
  return router.options.routes
    .filter(route => route.meta?.trackRecent)
    .map(route => ({
      path: route.path,
      name: route.name || route.path.replace('/', ''),
      icon: iconMap[route.meta?.icon] || iconMap.default
    }))
})

// Methods
const getRandomColor = () => {
  return colorPalette[
    Math.floor(Math.random() * colorPalette.length)
  ]
}

const formatTime = (timestamp) => {
  const seconds = Math.floor((Date.now() - timestamp) / 1000)
  if (seconds < 60) return `${seconds} sec ago`
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`
  return `${Math.floor(seconds / 86400)} days ago`
}

const trackNavigation = (path) => {
  store.dispatch('trackPageVisit', {
    path,
    timestamp: Date.now(),
    color: getRandomColor(),
    ...routerConfig.value.find(r => r.path === path)
  })
}

const navigateTo = (path) => {
  trackNavigation(path)
  router.push(path)
}

// If you need to access auth module (example)
//const authState = computed(() => store.state.auth) // Access auth module state
// const someAuthGetter = computed(() => store.getters['auth/someGetter'])
// const someAuthAction = () => store.dispatch('auth/someAction')
</script>


<style scoped>

.recent-pages-button {
  /* Circle shape */
  width: 56px;
  height: 56px;
  aspect-ratio: 1;
  border-radius: 50%;
  
  /* Bootstrap primary button styles */
  background-color: var(--bs-primary);
  border: none;
  color: white;
  
  /* Center icon */
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Shadow and hover effects */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}

.recent-pages-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.recent-pages-button i {
  font-size: 1.25rem;
}

.floating-recent-pages {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1050;
}

.mobile-recent-pages {
  z-index: 1050;
}

.recent-page-btn {
  min-width: 100px;
  color: white;
  border-radius: 20px;
  white-space: nowrap;
}

.recent-page-icon {
  width: 24px;
  text-align: center;
}

.dropdown-menu {
  min-width: 300px;
  max-height: 60vh;
  overflow-y: auto;
}

.dropdown-item {
  border-radius: 5px;
  margin: 2px 0;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}
</style>